import { render, staticRenderFns } from "./passEditPage.vue?vue&type=template&id=573e11d4&"
import script from "./passEditPage.vue?vue&type=script&lang=ts&"
export * from "./passEditPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports